/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateProjectRequest
 */
export interface CreateProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateProjectRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProjectRequest
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProjectRequest
     */
    photoURL?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProjectRequest
     */
    photosURL?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateProjectRequest
     */
    targetBudget?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProjectRequest
     */
    commercialArea?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProjectRequest
     */
    livableArea?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateProjectRequest
     */
    status: CreateProjectRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateProjectRequest
     */
    organizationId: string;
    /**
     * 
     * @type {number}
     * @memberof CreateProjectRequest
     */
    pricePerMeterSquare?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProjectRequest
     */
    pricePerMeterSquareCommercial?: number;
}


/**
 * @export
 */
export const CreateProjectRequestStatusEnum = {
    Active: 'active',
    Completed: 'completed',
    Archived: 'archived'
} as const;
export type CreateProjectRequestStatusEnum = typeof CreateProjectRequestStatusEnum[keyof typeof CreateProjectRequestStatusEnum];


/**
 * Check if a given object implements the CreateProjectRequest interface.
 */
export function instanceOfCreateProjectRequest(value: object): value is CreateProjectRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    return true;
}

export function CreateProjectRequestFromJSON(json: any): CreateProjectRequest {
    return CreateProjectRequestFromJSONTyped(json, false);
}

export function CreateProjectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProjectRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'address': json['address'] == null ? undefined : json['address'],
        'photoURL': json['photoURL'] == null ? undefined : json['photoURL'],
        'photosURL': json['photosURL'] == null ? undefined : json['photosURL'],
        'targetBudget': json['targetBudget'] == null ? undefined : json['targetBudget'],
        'commercialArea': json['commercialArea'] == null ? undefined : json['commercialArea'],
        'livableArea': json['livableArea'] == null ? undefined : json['livableArea'],
        'status': json['status'],
        'organizationId': json['organizationId'],
        'pricePerMeterSquare': json['pricePerMeterSquare'] == null ? undefined : json['pricePerMeterSquare'],
        'pricePerMeterSquareCommercial': json['pricePerMeterSquareCommercial'] == null ? undefined : json['pricePerMeterSquareCommercial'],
    };
}

export function CreateProjectRequestToJSON(json: any): CreateProjectRequest {
    return CreateProjectRequestToJSONTyped(json, false);
}

export function CreateProjectRequestToJSONTyped(value?: CreateProjectRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'address': value['address'],
        'photoURL': value['photoURL'],
        'photosURL': value['photosURL'],
        'targetBudget': value['targetBudget'],
        'commercialArea': value['commercialArea'],
        'livableArea': value['livableArea'],
        'status': value['status'],
        'organizationId': value['organizationId'],
        'pricePerMeterSquare': value['pricePerMeterSquare'],
        'pricePerMeterSquareCommercial': value['pricePerMeterSquareCommercial'],
    };
}

